<template>
  <div id="userAccount" :class="['gradient-card card', {'plain-card': ($utils.isPageForLicenses())}]">
    <div class="header">
      <div :class="panelHeaderIcon"></div>
        <h4 class="title">{{ panelHeaderTitle }}</h4>
      </div>

    <div class="body user-details">
      <div v-if="panelContent === 'userDetails'" class="user-details-content">
        <div :class="panelAcccountIcon">
          <img v-if="loginProvider === 'arya'" :src="accountLogo.url">
        </div>

        <div class="txt-lbl">{{$t('label.email')}}</div>
        <div class="txt-val email">{{email}}</div>
        <el-button v-if="loginProvider === 'arya'"
          @click="handleChangeAccountBtnClick('changeEmail')"
          :class="['cstm-icon-btn-medium ', 'normal-opacity', 'edit_white', 'change-email-btn']">
        </el-button>

        <template v-if="loginProvider === 'arya'">
          <div class="txt-lbl">{{$t('label.password')}}</div>
          <el-button @click="handleChangeAccountBtnClick('changePassword')"
            :class="['cstm-icon-btn-medium ', 'normal-opacity', 'edit_white']">
          </el-button>
        </template>

        <div class="account-ref">
          <div class="txt-lbl">{{$t('label.account')}}</div>
          <span v-if="accountGroupId" class="group-val">{{accountGroupId}}</span>
          <span v-else-if="accountUserId" class="user-val">{{accountUserId}}</span>
        </div>
      </div>

      <!-- Change Email Content -->
      <div v-if="panelContent === 'changeEmail'" class="change-email-content">
        <el-form :model="changeEmailForm" :rules="changeEmailFormRules" ref="changeEmailForm" @submit.prevent class="change-email-form">
          <el-form-item class="email f-item" prop="email">
            <el-input
              id="user-account-email-input"
              :model-value="changeEmailForm.email"
              @update:model-value="newValue => changeEmailForm.email = newValue"
              :placeholder="`* ${$t('label.newEmail')}`"
              class="cstm-input-white">
            </el-input>
          </el-form-item>
        </el-form>

        <el-button @click="confirmChangeEmail" class="cstm-btn-white new-email-confirm-btn">{{$t('label.ok')}}</el-button>
      </div>

      <!-- Change Password Content -->
      <div v-if="['changePassword', 'passwordChanged'].includes(panelContent)" class="change-password-content">
        <reset-password
          v-if="panelContent === 'changePassword'"
          class="h-[calc(100%-28px)]!"
          is-auto-verify-email
          :is-page-mini="isPageMini"
          :email="email"
          @success-submit="handleChangeAccountBtnClick('passwordChanged')">
        </reset-password>
        <div
          v-else
          class="max-[1919px]:py-16 min-[1920px]:py-20 max-[1919px]:text-xs min-[1920px]:text-md text-white text-center">
          <p>{{$t('label.passwordHasBeenChanged')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./user-account.js"></script>
<style lang="scss" src="./user-account.scss"></style>
